export default __webpack_public_path__ + "static/kassirru-f575f393e0b82ce68021033bae2db81d.png";